export default __webpack_public_path__ + "static/media/SELLING 3.4e1cf40b.png";